const lang = {
    "en-US": {
        search : "Search",
        gptSearchPlaceHolder : "What would you like to watch today?"
    },
    "hindi":{
        search : "खोज",
        gptSearchPlaceHolder : "आज आप क्या देखना चाहेंगे?"
    },
    "spanish":{
        search : "Buscar",
        gptSearchPlaceHolder : "¿Qué te gustaría ver hoy?"
    }
}

export default lang